import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TextContent } from '../../models/text-content.model';
import { GlobalElementType } from '../../enums/global-element-type-uid.enum';

@Component({
  selector: 'vm-tile-section',
  templateUrl: './tile-section.component.html',
  styleUrls: ['./tile-section.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TileSectionComponent {
  @Input() data: TextContent;
  globalElementType = GlobalElementType;
}
